const _ = require('lodash');
import ko from 'rgs-knockout';

function baseCategory () {
	const node = function () {
		const src = {
			CategoryId: '',
			Name: '',
			SelectedChildId: ko.observable(),
			Children: ko.observableArray(),
		};

		src.toJS = function () {
			return { ID: src.CategoryId, Name: src.Name };
		};

		src.hasChildren = ko.pureComputed(function (){
			return src.Children().length > 0;
		});

		src.SelectedChildId.extend({
			required: {
				params: true,
				onlyIf: function (){
					return src.Children().length > 0;
				},
			},
		});

		return src;
	};

	function init (category, children){
		const _node = _.extend(new node(), category);
		if (children) {
			_node.Children(children);
		}

		return _node;
	}

	function empty (){
		return new node();
	}

	return { init: init, empty: empty };
}

function categoriesApi (obsSource) {
	const baseCategories = baseCategory();
	const src = obsSource;
	const currentCategories = ko.observableArray();

	function setChilds (parents, assembledCategories)	{
		parents(
			_.transform(parents(), function (result, val){
				val = baseCategories.init(val, assembledCategories[val.CategoryId.toUpperCase()]);
				result.push(val);
				if (val.Children().length > 0){
					currentCategories.push(ko.pureComputed(() => val.SelectedChildId()));
					setChilds(val.Children, assembledCategories);
				}
			}, [])
		);
	}

	function getChilds (result, childID, childs) {
		if (!childID && !childs) {
			return;
		}

		_.each(childs, function (val){
			if (val.CategoryId.toUpperCase() !== (childID || '').toUpperCase()) {
				return;
			}

			result.push(val.toJS());
			getChilds(result, val.SelectedChildId(), val.Children());
		});
	}

	function setDefaultCategory (categoryId){
		src().SelectedChildId(categoryId);
	}

	function init (assembledCategories)	{
		src(baseCategories.init({}, assembledCategories['ROOT']));
		currentCategories.push(ko.pureComputed(function (){
			return src().SelectedChildId();
		}));
		setChilds(src().Children, assembledCategories);
		src().SelectedChildId.extend({ required: true });
	}

	function toJS (){
		const result = [];
		getChilds(result, src().SelectedChildId(), src().Children());

		return { Categories: result };
	}

	function checkCurrentCategories (checkValues, resultLen) {
		const curCat = _.transform(currentCategories(), function (result, v){
			result.push(v());
		}, []);
		const result = _.intersection(curCat, checkValues);
		return result.length === resultLen;
	}

	const visibleSection = {
		isPhoneService: ko.pureComputed(function () {
			return checkCurrentCategories([
				'2026ba4c-7372-4550-ba54-31f5e7f3fc82',
				'f305b808-f1fb-4015-b12d-6e1ae29ed56e',
				'0e090e8d-d209-4d7d-ae3b-1b08c193020e',
			], 3);
		}),
		isSelectOffice: ko.pureComputed(function () {
			return checkCurrentCategories([
				'2026ba4c-7372-4550-ba54-31f5e7f3fc82',
				'f305b808-f1fb-4015-b12d-6e1ae29ed56e',
				'0b83c478-821d-4311-ac92-577ee32ae0bc',
			], 3);
		}),
		isLiteClaimStatus: ko.pureComputed(function () {
			return checkCurrentCategories([
				'2026ba4c-7372-4550-ba54-31f5e7f3fc82',
				'6801c1b8-725b-4418-8f0f-b92e3ea4b25b',
				'893753d7-f155-491d-8b0c-7babe920e6b6',
				'65cb1b70-03d5-44e9-8383-dbb8e16cfac5',
				'1e22b1ad-014c-4104-a30b-8e7b06673341',
			], 4);
		}),
		isFullClaimStatus: ko.pureComputed(function () {
			return checkCurrentCategories([
				'2026ba4c-7372-4550-ba54-31f5e7f3fc82',
				'6801c1b8-725b-4418-8f0f-b92e3ea4b25b',
				'133388a2-3546-4a1b-821d-8040a95131e2',
				'3943ca50-f5da-4a17-867c-f229eb390acf',
				'ab71849e-2dc7-410a-8f66-7989602a5c82',
			], 3);
		}),
		isCompensation: ko.pureComputed(function () {
			return checkCurrentCategories([
				'2026ba4c-7372-4550-ba54-31f5e7f3fc82',
				'a2253d57-1998-46b6-9202-40b02630f78d',
			], 2);
		}),
		isKbm: ko.pureComputed(function () {
			return checkCurrentCategories([
				'08612f5b-5aba-4e16-86e0-d5aeed25df92',
				'940aec6e-2888-43ff-93b2-c0c85ef80f2f',
			], 1);
		}),
		isLifeSection: ko.pureComputed(function () {
			return checkCurrentCategories(['85377d50-2db7-4f86-84ee-dc5ba95323e0'], 1)
				|| checkCurrentCategories([
					'2026ba4c-7372-4550-ba54-31f5e7f3fc82',
					'75664e1a-f45c-4a7d-9972-dedd096c79a4',
				], 2);
		}),
	};
	function validationCategories () {
		function _nextCategories (result, parentId, childs) {
			if (!parentId) {
				return;
			}

			_.each(childs, function (val){
				if (val.Children().length === 0) {
					return;
				}

				if (!val.SelectedChildId() && val.CategoryId === parentId) {
					result.push(val.SelectedChildId);
				}

				_nextCategories(result, val.SelectedChildId(), val.Children());
			});
		}
		const result = [src().SelectedChildId];
		_nextCategories(result, src().SelectedChildId(), src().Children());

		return result;
	}

	return {
		init: init,
		toJS: toJS,
		setDefaultCategory: setDefaultCategory,
		currentCategories: currentCategories,
		validationCategories: validationCategories,
		visibleSection: visibleSection,
	};
}

function categories (){
	const src = ko.observable(baseCategory().empty());
	const api = categoriesApi(src);

	return {
		data: src,
		api: api,
	};
}

module.exports = categories;
